// Module
var code = `<div class="modify-order-screen">
    <orderInfoView order="{{order}}" />

    <terceraSeparator />

    <div class="modify-order-controls">
        <OEQuantity name="quantity"
                instrument="{{instrument}}"
                quantity="{{quantity}}"
                defaultQuantity="{{defaultQuantity}}" />

        <OEQuantity instrument="{{instrument}}"
                    visible="{{disclosedQuantityShow}}"
                    label="{{.disclosedLabel}}"
                    minValue="{{.dqMinValue}}"
                    maxValue="{{.dqMaxValue}}"
                    value="{{.disclosedQuantity.value}}"
                    defaultQuantity="{{disclosedQuantity}}"
                    tooltip="{{.dqTooltip}}"
                    valueLessMinLocalKey="{{.dqLessMinLocalKey}}"
                    valueGreaterMaxLocalKey="{{.dqGreaterMaxLocalKey}}"
                    noArrowCB="true" />

        <OETIFSelector orderType="{{orderType}}"
                    instrument="{{instrument}}"
                    defaultTif="{{defaultTif}}"
                    tif="{{tif}}" 
                    enabled="{{isRouteAllowModifyTIF}}" />

        <OEProductTypeSelector enabled="{{!disableProductType}}"
                            instrument="{{instrument}}"
                            account="{{account}}"
                            productType="{{productType}}" />

        <QuotePricePicker account="{{account}}"
                        instrument="{{instrument}}"
                        side="{{side}}"
                        on-pickPrice="onBreakevenClick" />

        <div class="order-edit-parameters">
            {{>orderEditControls orderEditParameterArray}}
        </div>

        {{#if .enableComment}}
            <OEComment needValidateEmpty="{{true}}" isUserCommentNotEmpty="{{enabledBtn}}" userComment="{{userComment}}" on-valueChanged="onUserCommentChanged"/>
        {{/if}}
    </div>

    <terceraSeparator />
</div>`;
// Exports
export default code;